import { render, staticRenderFns } from "./JDatePicker.vue?vue&type=template&id=8b746dc0&scoped=true&"
import script from "./JDatePicker.vue?vue&type=script&lang=js&"
export * from "./JDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./JDatePicker.vue?vue&type=style&index=0&id=8b746dc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b746dc0",
  null
  
)

export default component.exports